import { useEffect, useState } from 'react';
import { fetchScoreCategoryMetadata } from '../../services/healthWellness/healthSpan.service';
import { UI_CATEGORY_TO_METADATA_KEY } from './healthSpanScore.utils';

/**
 * Fetch score-category-metadata for a UI category (nutrition, metabolism, ...)
 * @param {string} uiCategory
 * @returns {{ metadata: Object|null, metaLoading: boolean }}
 */
export const useScoreCategoryMetadata = (uiCategory) => {
  const [metadata, setMetadata] = useState(null);
  const [metaLoading, setMetaLoading] = useState(true);

  useEffect(() => {
    const categoryKey = UI_CATEGORY_TO_METADATA_KEY[uiCategory];
    if (!categoryKey) {
      setMetadata(null);
      setMetaLoading(false);
      return undefined;
    }

    let cancelled = false;
    setMetaLoading(true);
    fetchScoreCategoryMetadata(categoryKey)
      .then((data) => {
        if (!cancelled) setMetadata(data?.metadata || null);
      })
      .catch(() => {
        if (!cancelled) setMetadata(null);
      })
      .finally(() => {
        if (!cancelled) setMetaLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [uiCategory]);

  return { metadata, metaLoading };
};
